import { getLocalTimeZone, now } from "@internationalized/date"
import { Link, useParams, useSearch } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import Logo from "@/assets/logos/inflow/inflow-royal.svg"
import Separator from "@/globalComponents/atoms/Separator"
import Text from "@/globalComponents/atoms/Text"
import { getQrLookupIDFromRoute } from "@/utilities/hooks/useTheme"

function Footer() {
  const params = useParams({ strict: false })
  const search = useSearch({ strict: false })
  const { t } = useTranslation()

  const qrLookupID = getQrLookupIDFromRoute({ params, search })

  return (
    <footer>
      <div className="footer-logo">
        <Logo />
      </div>
      <div className="footer-links">
        {qrLookupID ? (
          <Link
            to="/qr/$qrLookupID/privacy-policy"
            params={{ qrLookupID }}
            className="body--3"
            preload={false}
          >
            {t("navigation.footer.privacyPolicy")}
          </Link>
        ) : (
          <Link to="/privacy-policy" className="body--3" preload={false}>
            {t("navigation.footer.privacyPolicy")}
          </Link>
        )}
        <Separator orientation="vertical" />
        {qrLookupID ? (
          <Link
            to="/qr/$qrLookupID/terms-of-use"
            params={{ qrLookupID }}
            className="body--3"
            preload={false}
          >
            {t("navigation.footer.termsOfUser")}
          </Link>
        ) : (
          <Link to="/terms-of-use" className="body--3" preload={false}>
            {t("navigation.footer.termsOfUser")}
          </Link>
        )}
      </div>
      <div>
        <Text level={3} className="center">
          {t("navigation.footer.copyright", {
            currentYear: now(getLocalTimeZone()).year,
          })}
        </Text>
      </div>
    </footer>
  )
}

export default Footer
